export default function reloadPage(action) {
  const targetUrl = action.getAttribute('data-target-url');

  if (!!targetUrl && targetUrl.length > 0) {
    window.location.href = targetUrl;
  } else {
    window.location.reload();
  }
}
